// extracted by mini-css-extract-plugin
export default {"events":"events_events__wVb0F","container":"events_container__gSwgi","tabs":"events_tabs__0cazK","tabActive":"events_tabActive__QlKIn"};